import { useState } from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { BarChart3, Users, Cpu, Megaphone, Brain, ArrowLeft, Shield, ListTodo, ScrollText, Menu, X, GitBranch, FileText, DollarSign, Settings, Mail } from 'lucide-react';

export function AdminLayout() {
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const navItems = [
    { to: '/admin/f47ac10b58cc/dashboard', label: 'Dashboard', icon: BarChart3 },
    { to: '/admin/f47ac10b58cc/users', label: 'Users', icon: Users },
    { to: '/admin/f47ac10b58cc/pricing', label: 'Pricing', icon: DollarSign },
    { to: '/admin/f47ac10b58cc/data-flows', label: 'Data Flows', icon: GitBranch },
    { to: '/admin/f47ac10b58cc/marketing', label: 'Marketing', icon: Megaphone },
    { to: '/admin/f47ac10b58cc/models', label: 'AI Config', icon: Brain },
    { to: '/admin/f47ac10b58cc/ai-usage', label: 'AI Usage', icon: Cpu },
    { to: '/admin/f47ac10b58cc/pdf-calibration', label: 'PDF Calibration', icon: FileText },
    { to: '/admin/f47ac10b58cc/work-queue', label: 'Work Queue', icon: ListTodo },
    { to: '/admin/f47ac10b58cc/communications', label: 'Communications', icon: Mail },
    { to: '/admin/f47ac10b58cc/global-settings', label: 'Global Settings', icon: Settings },
    { to: '/admin/f47ac10b58cc/logs', label: 'Logs', icon: ScrollText },
  ];

  return (
    <div className="min-h-screen flex bg-gray-100">
      {/* Mobile header bar */}
      <div className="md:hidden fixed top-0 left-0 right-0 z-40 bg-gray-900 text-white flex items-center gap-2 px-4 py-3">
        <button onClick={() => setSidebarOpen(!sidebarOpen)} className="p-1">
          {sidebarOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
        <Shield className="w-5 h-5 text-primary-400" />
        <span className="font-bold">SkillSnap Admin</span>
      </div>

      {/* Mobile overlay backdrop */}
      {sidebarOpen && (
        <div
          className="md:hidden fixed inset-0 z-30 bg-black/50"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Sidebar */}
      <aside className={`
        fixed z-30 top-0 left-0 h-full w-64 bg-gray-900 text-white flex flex-col overflow-y-auto
        transform transition-transform duration-200 ease-in-out
        ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'} md:translate-x-0
      `}>
        <div className="p-4 border-b border-gray-700">
          <div className="flex items-center gap-2">
            <Shield className="w-6 h-6 text-primary-400" />
            <span className="text-lg font-bold">SkillSnap Admin</span>
          </div>
        </div>

        <nav className="flex-1 p-4 space-y-1">
          {navItems.map(({ to, label, icon: Icon }) => (
            <NavLink
              key={to}
              to={to}
              onClick={() => setSidebarOpen(false)}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2 rounded-lg transition-colors ${
                  isActive
                    ? 'bg-primary-600 text-white'
                    : 'text-gray-300 hover:bg-gray-800 hover:text-white'
                }`
              }
            >
              <Icon className="w-5 h-5" />
              <span>{label}</span>
            </NavLink>
          ))}
        </nav>

        <div className="p-4 border-t border-gray-700">
          <button
            onClick={() => navigate('/')}
            className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors w-full"
          >
            <ArrowLeft className="w-4 h-4" />
            <span>Back to App</span>
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <main className="flex-1 overflow-auto pt-12 md:pt-0 md:ml-64">
        <Outlet />
      </main>
    </div>
  );
}
